// extracted by mini-css-extract-plugin
export default {"root":"root___pyzUF","main":"main___t9QOP","title":"title___v9z5X","content":"content___BGMv_","contentBody":"contentBody___d1_it","footer":"footer___dWlib","link":"link___QlUQ1"};